import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'

import { SingleActionMenuItem } from './SingleActionMenuItem'

export const SingleActionMenu = ({ items, icon, className, disabled, callback, tooltipText }) => {
  const ref = useRef(null)

  const [open, setOpen] = useState(false)

  const iconClasses = classNames(icon, 'black-others', {
  })

  const containerClasses = classNames(className, 'dropdown table-header_dropdown', {
    'open': open
  })

  /*
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
  })
  */

  useEffect(() => {
    //  mount
    ReactTooltip.rebuild()
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      //  unmount
      ReactTooltip.rebuild()
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  function handleClick () {
    setOpen(!open)
  }

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false)
    }
  }

  const containerTip = (disabled) ? tooltipText : ''

  return (
    <>
      <div className={containerClasses} onClick={handleClick} ref={ref} data-tip={containerTip}>

        <button className={iconClasses} disabled={disabled} data-tip={tooltipText}>
          <i />
        </button>
        {items &&
        <ul className='dropdown-menu dropdown-menu_discendant dropdown-menu_white'>
          {items.map((item, key) =>
            (<SingleActionMenuItem key={key} {...item} onClick={callback} />)
          )}
        </ul>
        }
      </div>
    </>
  )
}

SingleActionMenu.defaultProps = {
  isOnlyText: true
}

SingleActionMenu.propTypes = {

  icon: PropTypes.string,
  callback: PropTypes.func,
  className: PropTypes.string,
  data: PropTypes.string,
  tooltipText: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    command: PropTypes.string,
    className: PropTypes.string
  }))

}
